var syncing = false;
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.mrk_money_format;
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// product page logic start here

function buildRequestUrl() {
  const _this = $('frame-variant-picker');
  if ($(_this).length == 0) { return }
  const section_id = $(_this).parents('.shopify-section').attr('id').replace('shopify-section-', '');
  const selectedOption = $('frame-variant-picker input:checked'); // Get the checked input
  const optionValueId = selectedOption.data('option-value-id'); // Get its data-option-value-id

  if (!optionValueId) {
    return; // If no option value ID is found, return nothing
  }

  const productUrl = $(_this).data('product-url');

  return `${productUrl}?section_id=${section_id}&option_values=${optionValueId}&view=frame`;
}
function updatePrices(prices) {
  var final_price = 0;
  var final_Compare_at_price = 0;
  prices.map(p => {
    final_price = final_price + p.price;
    final_Compare_at_price = final_Compare_at_price + p.compare_price;
  });
  var discount = (final_Compare_at_price - final_price) * 100 / final_Compare_at_price;
  $('.mrk-discount-percent').html(discount.toFixed(0));
  $('.mrk-main-price').html(Shopify.formatMoney(final_price));
  $('.mrk-main-compare-price').html(Shopify.formatMoney(final_Compare_at_price));
  if (discount > 0) {
    $('.mrk-sale-badge-wrapper').show();
    $('.mrk-main-compare-price').show();
  } else {
    $('.mrk-sale-badge-wrapper').hide();
    $('.mrk-main-compare-price').hide();
  }
}
function RemoveUnavailableVariants() {
  if (window.availableFrameIDs.length) {
    $('.mrk-child-frame-item').each(function () {
      const variantId = Number($(this).attr('variant-id'));
      if (!window.availableFrameIDs.includes(variantId)) {
        $(this).remove();
      }
    });
    if ($('.mrk-child-frame-item').length <= 3) {
      $('.mrk-child-frame-item').parents('.mrk-swatches-slider-wrapper').find('.slideshow-controls__arrows').hide();
    } else {
      $('.mrk-child-frame-item').parents('.mrk-swatches-slider-wrapper').find('.slideshow-controls__arrows').show();
    }
  }

}
function getMainParentVariant(main_variant) {
  var frame_swatch = $(`variant-picker [frame-color="${$('.mrk-frame-switcher input:checked').val().toLowerCase()}"]`).val();
  return window.main_product_data.find(v =>
    v.option1 === main_variant.option1 &&
    v.option2 === frame_swatch
  );
}
// Framing system selection - parent-only ("framed_print_only") vs parent+child ("child_frame").
// Resolution priority: variant metafield override -> product size list -> derived from child_frames.
function getFramingMode(main_variant) {
  if (!main_variant || main_variant.id == null) return 'Child frame';

  var vid = String(main_variant.id);
  var fpoVariantIds = (window.framed_print_only_variant_ids || []).map(String);
  var cfVariantIds = (window.child_frame_variant_ids || []).map(String);
  if (fpoVariantIds.indexOf(vid) > -1) return 'Framed print only';
  if (cfVariantIds.indexOf(vid) > -1) return 'Child frame';
  // If the merchant has explicitly marked some variants as "Child frame",
  // treat the marked list as an allowlist - any variant outside it is parent-only.
  if (cfVariantIds.length > 0) return 'Framed print only';

  var size = String(main_variant.option1 || '').trim().toLowerCase();
  var norm = function (s) { return String(s).trim().toLowerCase(); };
  var fpoSizes = (window.framed_print_only_sizes || []).map(norm);
  var childSizes = (window.child_frame_sizes || []).map(norm);

  if (fpoSizes.indexOf(size) > -1) return 'Framed print only';
  // Implicit fallback: if the product declares which sizes have child frames
  // and the selected size is not in that set, treat it as framed-print-only.
  if (childSizes.length && childSizes.indexOf(size) === -1) return 'Framed print only';
  return 'Child frame';
}
function updateVariants() {
  var main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}'),
    child_frame = $('[name="framing-service"]').is(':checked'),
    fulfillment_function = $('.mrk-fullfilment-sku').length,
    free_framing_service_data = JSON.parse($('#mrk-framing-service-data').text() || '{}'),
    free_framing_service = free_framing_service_data.free_framing_service || window.free_framing_service,
    frame = $('.mrk-frame-switcher input:checked'),
    frame_price = $(frame).data('variantPrice'),
    frame_compare_price = $(frame).data('variantComparePrice'),
    framing_service = !$('[name="framing-service"]').is(':checked'),
    framing_service_variant = $('[name="framing-service"]').val(),
    framing_service_compare_price = $('[name="framing-service"]').data('comparePrice'),
    framing_service_price = $('[name="framing-service"]').data('price'),
    frame_variant = $(frame).data('variantId'),
    frame_id = $('media-gallery .mrk-active-gallery-frame').data('frameId'),
    is_unframed = frame_variant ? false : true,
    variant_title = main_variant.title || '',
    size = (variant_title.match(/\(([^)]+)\)/) || [])[1] || '',
    mrk_sku = '',
    variants = [],
    prices = [];
  var framing_mode = getFramingMode(main_variant);
  var force_fpo = framing_mode === 'Framed print only';
  // "Child frame" mode is fully legacy: pricing, cart line, and the unframed-
  // parent vs. framed-parent decision are all driven by the framing-service
  // checkbox below. No force_cf override - keep the original child/parent
  // system intact for those variants.
  $('body').toggleClass('mrk-fpo-active', force_fpo);
  if (force_fpo) {
    // Framed-Print-Only: artwork variant already includes the frame.
    // No child frame item, no framing service line; submit only the parent variant.
    if (frame_id) {
      $('.mrk-frame-id').val(frame_id).prop('disabled', false);
    } else {
      $('.mrk-frame-id').prop('disabled', true);
    }
    $('.mrk-framing-service-wrapper:not(.bundle)').hide();
    // When the variant has the free-framing toggle on, surface the "free
    // framing" message on the product page even in FPO mode (the framing is
    // included in the variant - we just want the user to see it's free).
    if (free_framing_service) {
      $('.free-framing-service:not(.bundle)').show();
    } else {
      $('.free-framing-service:not(.bundle)').hide();
    }
  } else if (!is_unframed) {
    if (fulfillment_function || (!fulfillment_function && child_frame)) {
      variants.push({ id: frame_variant, parent_id: main_variant.id });
      prices.push({ price: frame_price, compare_price: frame_compare_price });
      mrk_sku = size + '-' + ($('.mrk-frame-switcher input:checked').val() || '').toString().toUpperCase() + '-FRAME';
    } else {
      var mrk_variant = getMainParentVariant(main_variant)
      main_variant = mrk_variant;
    }
    if (framing_service) {
      if (!free_framing_service) {
        variants.push({ id: framing_service_variant, parent_id: main_variant.id });
        prices.push({ price: framing_service_price, compare_price: framing_service_compare_price });
      }
      mrk_sku = size + '-FRAMED-' + ($('.mrk-frame-switcher input:checked').val() || '').toString().toUpperCase();
    }

    $('.mrk-frame-id').val(frame_id).prop('disabled', false);
    $('.mrk-framing-service-wrapper:not(.bundle)').show();
    if (free_framing_service) {
      $('.mrk-framing-service-wrapper:not(.bundle)').hide();
      $('.free-framing-service:not(.bundle)').show();
    } else {
      $('.free-framing-service:not(.bundle)').hide();
      $('.mrk-framing-service-wrapper:not(.bundle)').show();
    }
  } else {
    var mrk_variant = getMainParentVariant(main_variant)
    main_variant = mrk_variant;
    $('.free-framing-service:not(.bundle)').hide();
    $('.mrk-framing-service-wrapper:not(.bundle)').hide();
    $('.mrk-frame-id').prop('disabled', true);
  }

  prices.push({ price: main_variant.price, compare_price: main_variant.compare_at_price || main_variant.price });

  updatePrices(prices);
  $('.mrk-product-form-wrapper [name="items[0][id]"]').val(main_variant.id);
  $('.mrk-fullfilment-sku').val(mrk_sku);
  var inputs = '';
  variants.forEach(function (v, i) {
    var idx = i + 1;
    inputs += '<input name="items[' + idx + '][id]" type="hidden" value="' + (v.id || '') + '" />\n';
    inputs += '<input name="items[' + idx + '][parent_id]" type="hidden" value="' + (v.parent_id || '') + '" />\n';
  });

  $('.mrk-hidden-inputs').empty().append(inputs);
  if (!force_fpo && !fulfillment_function && child_frame) {
    $('.mrk-hidden-inputs').append('<input name="items[0][properties[_main_variant]]" type="hidden" value="' + (getMainParentVariant(main_variant).id || '') + '" />')
  }
  var frame_color_value = force_fpo ? (main_variant.option2 || '') : $(frame).val();
  $('.mrk-frame-color').val(frame_color_value).prop('disabled', false);
  $('.mrk-bundle-id').val(Math.floor((Date.now() % 100000) * Math.random())).prop('disabled', false);
}
function alreadyCheckedFrame() {
  $(`.mrk-frame-switcher input[frame-color="${window.selected_frame}"]`).prop('checked', true).trigger('change');
  setTimeout(function () {
    if ($('.mrk-frame-switcher input:checked').attr('frame-color') != window.selected_frame) {
      $(`.mrk-frame-switcher input[frame-color="${window.selected_frame}"]`).prop('checked', true).trigger('change');
    }
    if($(`.mrk-frame-switcher input[frame-color="${window.selected_frame}"]`).length == 0){
      $(`.mrk-frame-switcher input[frame-color]`).prop('checked', true).trigger('change');
    }
  }, 100)
}
function initStickyAddToCart() {
  var $FormWrapper = $('.product-details product-form-component:not(.mrk-bundle-form)');
  if ($FormWrapper.length) {
    var lastScrollTop = 0;
    var originalHeight = $FormWrapper.outerHeight();
    $FormWrapper.css('--height', originalHeight + 'px');
    $(window).on('scroll', function () {
      var originalOffsetTop = $FormWrapper.offset().top + 100;
      var scrollTop = $(this).scrollTop();
      // Always add class when top bar has scrolled up past original position
      if (scrollTop > originalOffsetTop) {
        if (!$FormWrapper.hasClass('mrk-fixed-add-to-cart-form')) {
          $FormWrapper.addClass('mrk-fixed-add-to-cart-form');
        }
      } else {
        $FormWrapper.removeClass('mrk-fixed-add-to-cart-form');
        $FormWrapper.css('min-height', '');
      }

      // If user scrolls up while fixed, set min-height
      if (scrollTop < lastScrollTop && scrollTop > originalOffsetTop) {
        $FormWrapper.css('min-height', originalHeight + 'px');
      }

      lastScrollTop = scrollTop;
    });
  }
}
function initSwatchSlider() {
  var $wrapper = $('.mrk-swatches-wrapper');
  if ($wrapper.length == 0) {
    return
  }
  var $prevBtn = $('.mrk-swatches-slider-wrapper .slideshow-control[ref="previous"]');
  var $nextBtn = $('.mrk-swatches-slider-wrapper .slideshow-control[ref="next"]');
  var step = $('.mrk-swatches-slider-wrapper .variant-option__button-label--has-swatch:eq(0)').outerWidth(true) + 5;

  function updateButtons() {
    var scrollLeft = $wrapper.scrollLeft();
    var maxScroll = $wrapper[0].scrollWidth - $wrapper.outerWidth();

    $prevBtn.toggle(scrollLeft > 0);
    $nextBtn.toggle(scrollLeft < maxScroll - 1);
  }

  // Click events
  $('.mrk-swatches-slider-wrapper .slideshow-control').off('click').on('click', function () {
    var direction = $(this).attr('ref');
    var current = $wrapper.scrollLeft();

    if (direction === 'previous') {
      $wrapper.animate({ scrollLeft: current - step }, 150, updateButtons);
    } else {
      $wrapper.animate({ scrollLeft: current + step }, 150, updateButtons);
    }
  });

  // Initial + responsive update
  updateButtons();
  $(window).off('resize.swatchSlider').on('resize.swatchSlider', updateButtons);
}
function updateProductPageFrame() {
  if ($('variant-picker').length == 0) {
    return
  }
  // In FPO mode the frame-variant-picker is hidden and its :checked:eq(1) is
  // stale (typically the last/default frame, e.g. oak). Drive the gallery
  // image from the main variant-picker's frame swatch instead. Detect the
  // mode from the current main variant so we pick up size-driven transitions
  // even before body class catches up.
  var current_main_variant = {};
  try { current_main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}'); } catch (e) {}
  var is_fpo_now = typeof getFramingMode === 'function' && getFramingMode(current_main_variant) === 'Framed print only';
  var frameName;
  if (is_fpo_now) {
    var $vpFrame = $('variant-picker input:checked').filter(function () {
      var fc = ($(this).attr('frame-color') || '').trim();
      return fc.length > 0;
    }).last();
    frameName = ($vpFrame.attr('frame-color') || '').toLowerCase();
  } else {
    var selectedFrame = $('frame-variant-picker input:checked:eq(1)');
    frameName = $(selectedFrame).val()?.toLowerCase();
  }
  $('media-gallery .mrk-featured-product-frame-wrapper .mrk-frame-image-item').removeClass('mrk-active-gallery-frame').hide();
  $(`media-gallery .mrk-frame-image-item[color="${frameName}"]`).addClass('mrk-active-gallery-frame').show();
  $(`.mrk-tab-trigger[data-content="${frameName}"]`).click();
  updateVariants();
}
function mrkApplyGiftAdjustments() {
  var el = document.getElementById('mrk-gift-json');
  if (!el) return;

  var items;
  try { items = JSON.parse(el.textContent || '[]'); } catch (e) { return; }
  if (!Array.isArray(items) || !items.length) return;

  // Only process items where new_qty is explicitly 0 (removal of free gifts)
  var itemsToRemove = items.filter(function(it) {
    return parseInt(it.new_qty, 10) === 0;
  });

  if (!itemsToRemove.length) return;

  // Build updates object with ONLY the gift item keys set to 0
  var updates = {};
  itemsToRemove.forEach(function(it) {
    var key = String(it.key || '');
    if (!key) return;
    updates[key] = 0;
  });

  if (!Object.keys(updates).length) return;

  // Get section IDs for cart refresh
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map(el => el.dataset.sectionId)
    .filter(Boolean);

  // Use /cart/update.js with specific keys — this only touches what you pass in
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: { updates: updates, sections: sectionIds }
  }).then(function(response) {
    if (typeof window.manualCartRefresh === 'function') {
      window.manualCartRefresh(response);
    }
  });
}
$(document).on('mrkBeforeVariantChanged', function (e) {
  var selectedOption = e.detail;
  $('.mrk-size-selector-wrapper details').prop('open', false);
  $('frame-variant-picker input').each(function () {
    if ($(this).val() === selectedOption) {
      $(this).prop('checked', true);
    }
  });
  if ($(`frame-variant-picker input[value='${selectedOption}']`).length == 0) {
    return;
  }
  window.selected_frame = $('.mrk-frame-switcher input:checked').attr('frame-color');
  var url = buildRequestUrl();
  $.get(url, function (response) {
    var variantPickerHtml = $(response).find('frame-variant-picker').html();
    $('frame-variant-picker').html(variantPickerHtml);
    RemoveUnavailableVariants();
    initSwatchSlider();
    alreadyCheckedFrame();
  });
  if (window.selected_frame) {
    $(`.mrk-tab-trigger[data-content="${window.selected_frame}"]`).click();
  } else {
    $(`.mrk-tab-trigger`).first().click();
  }
});
;(function () {
  // Module-scoped previous-framing-mode tracker, closed over by the handler.
  // Seeded by the bootstrap below from the initial main variant.
  var mrkPrevFramingMode = null;
  window.__mrkSeedPrevFramingMode = function (mode) {
    if (mrkPrevFramingMode === null && mode) mrkPrevFramingMode = mode;
  };

  $(document).on('mrkVariantChanged', function (e) {
    // Snap to Unframed ONLY on a real FPO -> Child-frame transition AND only
    // for products that use the child-frame system (frame-variant-picker is
    // rendered). Pure CF products would otherwise snap on every change
    // (cascades to oak), and "normal" products with mixed framing_sale_mode
    // metafields would snap any non-FPO pick back to Unframed.
    var newVariant = (e && e.detail) || {};
    var newMode = (newVariant && newVariant.option1 != null && typeof getFramingMode === 'function')
      ? getFramingMode(newVariant)
      : null;
    var prevMode = mrkPrevFramingMode;
    // Update tracker BEFORE any early return so the snap's re-entrant
    // mrkVariantChanged sees prevMode === 'Child frame' and exits.
    if (newMode) mrkPrevFramingMode = newMode;

    if (newMode === 'Child frame' && prevMode === 'Framed print only' && $('frame-variant-picker').length > 0) {
      var unframedValue = String(window.mrk_unframed_value || 'Unframed').trim().toLowerCase();
      var currentOption2 = String(newVariant.option2 || '').trim().toLowerCase();
      if (currentOption2 && currentOption2 !== unframedValue) {
        var $unframedSwatch = $('variant-picker .variant-option--swatches input').filter(function () {
          return String($(this).val() || '').trim().toLowerCase() === unframedValue;
        }).first();
        if ($unframedSwatch.length && !$unframedSwatch.is(':checked')) {
          $unframedSwatch[0].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    alreadyCheckedFrame();
    if (!$('frame-variant-picker').length) {
      var frame_id = $('media-gallery .mrk-active-gallery-frame').data('frameId');
      if (frame_id) $('.mrk-frame-id').val(frame_id).prop('disabled', false);
    }
  });
})();
$(document).on('change', '.mrk-frame-switcher input', updateProductPageFrame);
$(document).on('change', '[name="framing-service"]', updateProductPageFrame);
// $(document).on('click', '.mrk-swatches-slider-wrapper .slideshow-control', function () {
//   var width = $('.mrk-swatches-slider-wrapper .variant-option__button-label--has-swatch:eq(0)').outerWidth(true) + 5;
//   var $wrapper = $('.mrk-swatches-wrapper');
//   var current = $wrapper.scrollLeft();
//   var ref = $(this).attr('ref');

//   if (ref === 'previous') {
//     $wrapper.animate({ scrollLeft: current - width }, 100);
//   } else if (ref === 'next') {
//     $wrapper.animate({ scrollLeft: current + width }, 100);
//   }
// });

function updateFrame(){
  if ($('[name="mrk-collection-frame"]:checked').length) {
    var selected_frame = $('[name="mrk-collection-frame"]:checked').val().toLowerCase();
    $('.mrk-frame-image-item').hide();
    $('.mrk-collection-item-frames-wrapper').removeClass('mrk-collection-frame-item-active');
    $(`.mrk-frame-wrapper`).each(function () {
      if ($(this).find(`.mrk-frame-image-item[color="${selected_frame}"]`).length) {
        $(this).find(`.mrk-frame-image-item[color="${selected_frame}"]`).show();
        $(this).parents('.mrk-collection-item-frames-wrapper').addClass('mrk-collection-frame-item-active');
        // var url_item = $(this).parents('.boost-sd__product-link');
        // var url = $(url_item).attr('data-href') || $(url_item).attr('href');
        // var final_url = url + '?frame=' + selected_frame;
        // $(url_item).attr('href', final_url).attr('data-href', url)
      }
    })
  }
}
$(document).on('change', '[name="mrk-collection-frame"]', updateFrame);
$(document).on('click', '.mrk-detail-option-item', function (e) {
  e.preventDefault();
  e.stopPropagation();

  var $item = $(this);
  var $details = $item.closest('details');
  var $container = $item.closest('form') || $item.closest('details');
  var $target = $details.find('.mrk-selected-detail-value').first();
  var content = $item.find('.upsell-dropdown-option').first().html() || $item.find('.addon-dropdown-option').first().html();

  if (!content || !$target.length) return;

  // Replace the selected area's content with the clicked option's content
  $target.html(content);

  // Close the <details>
  $details.prop('open', false);

  var variant = $(this).attr('value') || '',
    color = $(this).attr('color') || '',
    frame_id = $(this).attr('frame_id') || '',
    main_variant = $(this).attr('main-variant') || '';
  var $input = $container.find('[name="items[1][id]"]');
  if (variant === '') {
    $input.prop('disabled', true).val('');
    $container.find('.upsell-parent-id').prop('disabled', true);
    $container.find('.mrk-cart-frame-add').prop('disabled', true);
  } else {
    $input.prop('disabled', false).val(variant).attr('color', color).attr('main-variant', main_variant).attr('frame_id', frame_id);
    $container.find('.upsell-parent-id').prop('disabled', false);
    $container.find('.mrk-cart-frame-add').prop('disabled', false);
    $container.find('.mrk-upsell-frame-color').prop('disabled', false).val(color);
  }
});
$(document).on('click', function (e) {
  const $details = $('.mrk-custom-detail[open]');
  if ($details.length && !$(e.target).closest('.mrk-custom-detail').length) {
    $details.prop('open', false);
  }
});
$(document).on('click', '.mrk-cart-upsell-form .mrk-custom-detail summary', function () {
  const details = $(this).parents('details');

  setTimeout(() => {
    if (details.prop('open')) {
      const dropdown = details.find('.mrk-upsell-option-dropdown')[0];
      if (dropdown) {
        dropdown.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }, 50);
});

$(document).on('click', '.mrk-tab-trigger', function () {
  const frame = $(this).data('content');
  $('.mrk-tab-trigger').removeClass('tab-active');
  $(this).addClass('tab-active');
  $('.mrk-tab-content-item').hide();
  $(`.mrk-tab-content-item[frame="${frame}"]`).show();
});
$(document).on('click', '.mrk-tab-item-btn', function () {
  const section = $(this).parents('.shopify-section'),
    tab = $(this).data('tab');
  const html = $(this).next('template').html(),
    image = $(html).find('img'), srcset = $(image).data('srcset'), src = $(image).data('src');
  if (image != undefined) {
    $(section).find('.main-tab-image')
      .attr({ 'data-srcset': srcset, 'data-src': src })
      .removeAttr('src srcset')
      .removeClass('lazyloaded ls-is-cached')
      .addClass('lazyload');
  }
  $(section).find('.mrk-tab-item-btn').removeClass('mrk-tab-active');
  $(this).addClass('mrk-tab-active');
  $(section).find('.mrk-tab-content').hide();
  $(`.mrk-tab-content[data-tab="${tab}"]`).show();

});
$(document).on('click', '.mrk-cart-frame-add', function (e) {
  e.preventDefault();
  var $w = $(this).closest('.mrk-cart-frame-upsell');
  var childId = Number($w.find('.mrk-frame-cart-addon-id').val());
  var color = $w.find('.mrk-frame-cart-addon-id').attr('color');
  var parentId = Number($w.find('.mrk-frame-cart-addon-id').attr('parentVariant'));
  var frame_id = Number($w.find('.mrk-frame-cart-addon-id').attr('frame_id'));
  var main_variant = $w.find('.mrk-frame-cart-addon-id').attr('main-variant');
  var add_parent = $w.find('.mrk-frame-cart-addon-id').attr('addparent') == 'true';
  if (!parentId || !childId) return alert('Select main & sub variants');
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  // 1️⃣ Remove parent variant first
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: parentId, quantity: 0 },
    dataType: 'json'
  }).always(function () {
    // 2️⃣ Build items array based on whether main-variant exists
    var items;
    if (add_parent) {
      items = [
        { id: parentId, quantity: 1, properties: { 'Color': color, '_main_variant': Number(main_variant), '_frame_id': frame_id } },
        { id: childId, quantity: 1, parent_id: parentId }
      ];
    } else {
      items = [
        { id: childId, quantity: 1, properties: { 'Color': color } }
      ];
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { items: items, sections: sectionIds }
    }).then(function (response) {
      window.manualCartRefresh(response);
    });
  });
});
$(document).on('click', '[href="#open-cart"]', function (e) {
  e.preventDefault();
  $('.mrk-cart-icon-button').trigger('click');
})
$(document).on('click', '.mrk-cart-framing-add', function (e) {
  e.preventDefault();

  const $btn = $(this);
  let parentId = Number($btn.attr('parent')) || 0;
  let childId = Number($btn.attr('frame')) || 0;
  if (Number($btn.attr('main_variant'))) {
    parentId = Number($btn.attr('main_variant'));
    childId = null;
  }
  const quantity = Number($btn.attr('quantity')) || 1;
  const framingServiceId = Number($btn.attr('framing')) || 0;
  const color = $btn.attr('color') || '';
  const frame_id = $btn.attr('frame_id') || '';
  const itemsToRemove = ($btn.attr('item-to-remove') || '').split(',');

  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map(el => el.dataset.sectionId)
    .filter(Boolean);

  const updates = {};
  itemsToRemove.forEach(id => { updates[id] = 0; });
  const removePromise = Object.keys(updates).length
    ? $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: { updates }
    })
    : $.Deferred().resolve().promise();

  removePromise.always(function () {
    const items = [];

    if (parentId) {
      const props = {};
      if (color) props['Framing'] = color;
      if (frame_id) props['_frame_id'] = frame_id;
      items.push({ id: parentId, quantity: quantity, properties: props });
    }
    if (childId && parentId) {
      items.push({ id: childId, quantity: quantity, parent_id: parentId });
    }
    if (framingServiceId && parentId) {
      items.push({ id: framingServiceId, quantity: quantity, parent_id: parentId });
    }

    if (!items.length) return;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items,
        sections: sectionIds
      }
    }).then(function (response) {
      if (typeof window.manualCartRefresh === 'function') {
        window.manualCartRefresh(response);
      }
    });
  });
});
$(document).on('cart:update cart:updated', function (e) {
  if (syncing) return;
  syncing = true;

  try {
  var changedInputs = [];
  var processed = new Set(); // to skip inputs we've handled via grouping

  // 1) Loop each parent line
  $('.cart-items__table-row[data-key]').each(function () {
    var $parent = $(this);
    var parentKey = $parent.attr('data-key');
    if (!parentKey) return;

    var $parentInput = $parent.find('input[name="updates[]"]');
    if (!$parentInput.length) return;

    var pQty = parseInt($parentInput.val(), 10) || 0;

    // 2) Find all children of this parent
    var $children = $('.cart-items__table-row[data-parent-key="' + parentKey + '"]');

    if (!$children.length) return;

    // Helper: extract variant id from data-key (before the first ":")
    var getVariantId = function ($row) {
      var key = $row.attr('data-key') || '';
      var idx = key.indexOf(':');
      return idx > -1 ? key.slice(0, idx) : key; // fall back to full key if no colon
    };

    // 3) Group children by variant id
    var groups = {};
    $children.each(function () {
      var $child = $(this);
      var $childInput = $child.find('input[name="updates[]"]');
      if (!$childInput.length) return;

      var vId = getVariantId($child);
      groups[vId] = groups[vId] || { inputs: [], sum: 0 };
      groups[vId].inputs.push($childInput);
      groups[vId].sum += (parseInt($childInput.val(), 10) || 0);
    });

    // 4) For each group:
    //    - if same variant appears in multiple lines, compare the SUM to the parent
    //    - if mismatch, set first to parent qty and zero-out the rest (keeps totals correct)
    //    - if only one line for that variant, fall back to the old 1:1 behavior
    Object.keys(groups).forEach(function (vId) {
      var g = groups[vId];

      if (g.inputs.length > 1) {
        // Multi-line split for the same variant (discount, promo, etc.)
        if (g.sum !== pQty) {
          // Put the full qty on the first line and zero-out others
          g.inputs.forEach(function ($input, idx) {
            var target = (idx === 0) ? pQty : 0;
            if ((parseInt($input.val(), 10) || 0) !== target) {
              $input.val(target);
              changedInputs.push($input[0]);
            }
            processed.add($input[0]);
          });
        } else {
          // Totals already match parent; mark as processed so we don't touch them again
          g.inputs.forEach(function ($input) {
            processed.add($input[0]);
          });
        }
      } else {
        // Single child line for this variant: keep the original 1:1 sync
        var $only = g.inputs[0];
        var cQty = parseInt($only.val(), 10) || 0;
        if (cQty !== pQty) {
          $only.val(pQty);
          changedInputs.push($only[0]);
        }
        processed.add($only[0]);
      }
    });
  });
  // 5) Still handle other (non-duplicate) child rows that weren’t processed above
  $('.cart-items__table-row[data-parent-key!=""]').each(function () {
    var $child = $(this);
    var $childInput = $child.find('input[name="updates[]"]');
    if (!$childInput.length) return;
    if (processed.has($childInput[0])) return; // already handled via grouping

    var parentKey = $child.attr('data-parent-key');
    var $parent = $('.cart-items__table-row[data-key="' + parentKey + '"]');
    if (!$parent.length) return;

    var $parentInput = $parent.find('input[name="updates[]"]');
    if (!$parentInput.length) return;

    var pQty = parseInt($parentInput.val(), 10) || 0;
    var cQty = parseInt($childInput.val(), 10) || 0;

    if (pQty !== cQty) {
      $childInput.val(pQty);
      changedInputs.push($childInput[0]);
    }
  });

  // 6) Fire events for anything we changed (covers custom listeners)
  if (changedInputs.length) {
    changedInputs.forEach(function (el) {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
      el.dispatchEvent(new Event('blur', { bubbles: true }));
    });
  }
  } catch (err) {
    // A single bad data-key / malformed value must not leave `syncing` stuck true,
    // which would make every later cart:update bail at `if (syncing) return;` and
    // freeze cart syncing for the rest of the session (only a full reload recovers).
    console.error('[mrk cart:update]', err);
  } finally {
    syncing = false;
  }
  mrkApplyGiftAdjustments()
});
$(document).on('click', '.mrk-custom-linked a', function (e) {
  e.preventDefault();
  var url = $(this).attr('href'),
  selected_size = $('.mrk-selected-option .mrk-size-item-title').text().trim(),
  selected_frame = $('frame-variant-picker .mrk-swatches-wrapper input:checked').attr('frame-color')?.toLowerCase() || $('variant-picker .mrk-swatches-wrapper input:checked').attr('frame-color').toLowerCase(),
  url = url + '?frame=' + selected_frame + '&size=' + selected_size;
  location.href = url;
})
$(function () {
  const frameColor = new URLSearchParams(window.location.search).get('frame');
  const selectedSize = new URLSearchParams(window.location.search).get('size');
  if (frameColor) {
    $('.mrk-swatches-wrapper [frame-color="' + frameColor + '"]').prop('checked', true).trigger('change');
    if ($('.mrk-swatches-wrapper').length) {
      document.dispatchEvent(new CustomEvent('mrkBeforeVariantChanged', {
        detail: $('.mrk-size-item-main input:checked').data('value')
      }));
    }
  }
  if (selectedSize) {
    $(`.mrk-size-item-main [data-value='${selectedSize}']`).prop('checked', true)[0].dispatchEvent(new Event('change', { bubbles: true }));
  }
  var frame = $('.mrk-frame-switcher input:checked');
  if ($(frame).length) {
    $('.mrk-frame-color').val($(frame).val()).prop('disabled', false);
  }
  RemoveUnavailableVariants();
  initStickyAddToCart();
  initSwatchSlider();
  // Bootstrap framing-mode body class so the size-specific CSS overrides
  // (frame-variant-picker hidden, framing-service hidden) apply on first paint.
  // We do NOT call updateVariants() here - the legacy code paths trigger it
  // through their own cascade, and calling it eagerly causes the picker to
  // re-fetch and feel like the page is reloading.
  if ($('#mrk-main-variant-data').length) {
    var bootstrap_main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}');
    var bootstrap_mode = getFramingMode(bootstrap_main_variant);
    $('body').toggleClass('mrk-fpo-active', bootstrap_mode === 'Framed print only');
    // Seed the prev-framing-mode tracker so the FIRST user-triggered
    // mrkVariantChanged has a correct previous mode.
    if (typeof window.__mrkSeedPrevFramingMode === 'function') {
      window.__mrkSeedPrevFramingMode(bootstrap_mode);
    }
  }
  if($('frame-variant-picker input').length && $('variant-picker input:checked:eq(0)').val() != $('frame-variant-picker input:checked:eq(0)').val()){
    $('variant-picker input:checked:eq(0)')[0].dispatchEvent(new Event('change', { bubbles: true }))
  }
  const params = new URLSearchParams(window.location.search);
  if (params.has('open-cart') || window.location.hash == '#open-cart') {
    $('cart-drawer-component .header-actions__action').trigger('click');
  }
  if (window.show_default_black_variant) {
    $('[color="black"]').show().addClass('mrk-active-gallery-frame')
  }
});